import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { InputDatePicker } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { CreateModalStore } from "./store";

type Props = {
  readonly store: CreateModalStore;
};

export const CreateModal = observer(function CreateModal({ store }: Props) {
  return (
    <Modal isOpen={store.isOpen} onClose={store.disclosureState.onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <HStack justify="space-between" pr="8">
            <Text>
              <Trans>Create Time Billing</Trans>
            </Text>
          </HStack>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <HStack spacing="4">
            <InputDatePicker
              label={t`Date From`}
              onChange={(val) => val && store.dateFrom.onChange(val.start)}
              selected={store.dateFrom.value}
            />

            <InputDatePicker
              label={t`Date To`}
              onChange={(val) => val && store.dateTo.onChange(val.start)}
              selected={store.dateTo.value}
            />
          </HStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing="2">
            <Button onClick={store.disclosureState.onClose} variant="ghost">
              <Trans>Cancel</Trans>
            </Button>

            <Button isLoading={store.isLoading} onClick={store.create}>
              <Trans>Create</Trans>
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
